<template>
  <div class="flex w-64 flex-col gap-3 p-3">
    <UiComboboxMultiVee
      name="bilagLanguageFilter"
      :label="$t('W: Sprog')"
      :modelValue="languageFilter"
      :options="languageOptions"
      :placeholder="$t('W: Alle sprog')"
      :searchPlaceholder="$t('term.search')"
      :emptyText="$t('W: Ingen resultater')"
      @update:model-value="languageFilter = $event" />

    <UiComboboxVee
      name="bilagVisibilityFilter"
      :label="$t('term.status')"
      :options="visibilityOptions"
      :modelValue="visibilityFilter"
      @update:model-value="visibilityFilter = $event" />

    <UiBaseButton
      v-if="isFiltering"
      :text="$t('W: Nulstil filtre')"
      theme="neutral"
      @button-click="resetFilters" />
  </div>
</template>

<script lang="ts">
import { useBilagLibraryItemStore } from '@/stores/bilagLibraryItemStore'
import { LAB_CUSTOMER_LANGUAGES } from '@team-milva/lab-models/language'
import type { TLibraryVisibilityFilter } from '@/globals/typescript/utils/libraryVisibilityFilter'
import { mapWritableState } from 'pinia'

export default {
  name: 'ReportAttachmentsFilterMenu',

  emits: ['close'],

  computed: {
    ...mapWritableState(useBilagLibraryItemStore, [
      'languageFilter',
      'visibilityFilter',
    ]),

    languageOptions(): { value: string; text: string }[] {
      return Object.values(LAB_CUSTOMER_LANGUAGES)
        .map((lang) => ({ value: lang.locale, text: lang.name }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    visibilityOptions(): { value: TLibraryVisibilityFilter; text: string }[] {
      return [
        { value: 'active', text: this.$t('state.active') },
        { value: 'active-inactive', text: this.$t('W: Aktive og inaktive') },
        { value: 'archived', text: this.$t('state.archived') },
        { value: 'all', text: this.$t('term.all') },
      ]
    },

    isFiltering(): boolean {
      return this.languageFilter.length > 0 || this.visibilityFilter !== 'active'
    },
  },

  methods: {
    resetFilters(): void {
      this.languageFilter = []
      this.visibilityFilter = 'active'
    },
  },
}
</script>
